<template>
	<auth-container :page="page">
		<h2 class="mb-4">Create New Planning &amp; Environmental Assessment Phase</h2>

		<sr-plan-env-assessment-form :item="item" :project="project" :showNoExist="showNoExist"></sr-plan-env-assessment-form>
	</auth-container>
</template>

<script>
	import SrPlanEnvAssessmentForm from './SrPlanEnvAssessmentForm.vue';
	export default {
		name: 'SrPlanEnvAssessmentCreate',
		components: {
			SrPlanEnvAssessmentForm
		},
		data() {
			return {
				page: {
					errors: [],
					loading: false,
					showLogin: false
				},
				item: {
					projectId: null,
					name: null,
					finalReportDate: null,
					nrcsContact: null,
					assignedAe: null,
					status: 0
				},
				project: null,
				shoNoExist: false
			}
		},
		async created() {
			await this.get();
		},
		watch: {
			'$route': 'get'
		},
		methods: {
			async get() {
				this.page.loading = true;
				this.page.errors = [];

				if (!this.isNullOrEmpty(this.$route.query.projectId)) {
					try {
						const response = await this.$http.get(`srprojects/getname/${this.$route.query.projectId}`, this.getTokenHeader());
						this.project = response.data;
						this.showNoExist = true;
					} catch (error) {
						if (this.isApiUnauthorized(error)) this.page.showLogin = true;
						else this.page.errors = this.logError(error);
					}
				}

				this.page.loading = false;
			}
		}
	}
</script>